const SET_SUBMISSION_CHOOSE = (state, payload) => {
  state.referenceData.subjectTypes = payload.subjectTypes;

  state.user = payload.user;
  state.usageEventsDisabled = payload.usageEventsDisabled;
};

export default SET_SUBMISSION_CHOOSE;
